import { render, staticRenderFns } from "./teamSales.vue?vue&type=template&id=21c02466&scoped=true"
import script from "./teamSales.vue?vue&type=script&lang=js"
export * from "./teamSales.vue?vue&type=script&lang=js"
import style0 from "./teamSales.vue?vue&type=style&index=0&id=21c02466&prod&lang=scss"
import style1 from "./teamSales.vue?vue&type=style&index=1&id=21c02466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c02466",
  null
  
)

export default component.exports